import { SearchQueryOrderDirection } from "types/generated";

export const FILTERS_TYPE = "policies";
export const FILTERS_ORDER_SETTINGS_KEY = "policiesFiltersOrder";

export enum FilterItemKeys {
  NAME = "name",
  TYPE = "type",
  SPACE = "space",
  CREATED_AT = "createdAt",
  UPDATED_AT = "updatedAt",
}

export const FILTER_ITEMS_DICTIONARY: Partial<Record<FilterItemKeys, string>> = {
  [FilterItemKeys.NAME]: "name",
  [FilterItemKeys.TYPE]: "type",
  [FilterItemKeys.SPACE]: "space",
  [FilterItemKeys.CREATED_AT]: "Created at",
  [FilterItemKeys.UPDATED_AT]: "Last update",
};

export const INITIAL_SORT_OPTION = FilterItemKeys.NAME;
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Asc;

export const ENTITIES_PER_PAGE = 50;

export const POLICIES_LIMIT_STORAGE_KEY = "policiesLimit";

// TODO: remove when backend apply login policy removal on their side
export const EXCLUDE_LOGIN_PREDICATE = {
  field: "type",
  exclude: true,
  constraint: {
    booleanEquals: null,
    enumEquals: ["LOGIN"],
    stringEquals: null,
    stringMatches: null,
    hierarchyNodeValueEquals: null,
    timeInRange: null,
    timeInLast: null,
  },
};

export const REFETCH_QUERIES_ON_DELETE = [
  "GetPolicyNames",
  "SearchPolicies",
  "SearchPoliciesSuggestions",
];

export const POLICIES_DISABLED_INFO_KEY = "policies-trial-info";

export const VIRTUALIZATION_THRESHOLD = 50;
